/** Firestore `users.badges` içinde saklanan rozet kimlikleri */
export const BADGE_BILGE_ANNEDAS = 'bilge_annedas';
export const BADGE_GUVENILIR_SATICI = 'guvenilir_satici';

export type BadgeId = typeof BADGE_BILGE_ANNEDAS | typeof BADGE_GUVENILIR_SATICI;

export function badgeMeta(id: string): { emoji: string; shortLabel: string } | null {
  switch (id) {
    case BADGE_BILGE_ANNEDAS:
      return { emoji: '🦉', shortLabel: 'Bilge' };
    case BADGE_GUVENILIR_SATICI:
      return { emoji: '⭐️', shortLabel: 'Güvenilir' };
    default:
      return null;
  }
}
